module.exports = __webpack_public_path__ + "static/media/hatchef.1cab13a3.svg";